import { x } from '@xstyled/styled-components';
import React, { Children } from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { LAYOUT_COLUMNS } from '../itemIds';

interface Props {
  gridTemplateColumns?: string | { _: string; lg: string };
  px?: string | { _: string; lg: string; md: string };
  py?: string | { _: string; lg: string; md: string };
  type?: string;
}

export type LayoutColumnsDefinition = ItemDefinition<
  typeof LAYOUT_COLUMNS,
  Props
>;

export class LayoutColumns extends Item<typeof LAYOUT_COLUMNS, Props> {
  protected render({
    gridTemplateColumns,
    px,
    py,
    type = 'div',
    children
  }: RenderProps<Props>) {
    const childArray = Children.toArray(children);

    if (!gridTemplateColumns) {
      gridTemplateColumns = {
        _: '1fr',
        lg: `repeat(${childArray.length}, 1fr)`
      };
    }

    if (!px) {
      px = { _: 'md', md: 'md', lg: 'xl' };
    }

    if (!py) {
      py = { _: 'xxxl', md: 'xl', lg: 'xl' };
    }

    return (
      <x.div
        as={type as never}
        w="100%"
        h="100%"
        px={px}
        py={py}
        gap={{ _: 'md', md: 'md', lg: 'xl' }}
        flex="1"
        display="grid"
        gridAutoFlow={{ _: 'row', lg: 'column' }}
        gridTemplateColumns={gridTemplateColumns}
        gridTemplateRows={{
          _: `repeat(${childArray.length}, auto)`,
          lg: '1fr'
        }}
      >
        {childArray.map((c, i) => (
          // minW=0: grid items default to min-width:auto and won't shrink below
          // fixed-width children (FbPost 359px, Envelope 350px, …) → H-scroll at 320.
          <x.div key={i} minWidth={0} w="100%">
            {c}
          </x.div>
        ))}
      </x.div>
    );
  }
}

registry[LAYOUT_COLUMNS] = LayoutColumns;
